<template>
  <div class="page">
    <div class="sub-nav-bar" v-if="team">
      <div class="sub-nav-button" @click="gotoTeam('resistance')" :class="{active: team === 'resistance'}">
        Mercenaries
      </div>
      <div class="sub-nav-button" @click="gotoTeam('civilians')" :class="{active: team === 'civilians'}">Civilians
      </div>
      <div class="sub-nav-button" @click="gotoTeam('coalitionForces')" :class="{active: team === 'coalitionForces'}">
        Nordland
      </div>
      <div class="" style="margin: 0">
        <div style="margin: 0" @click="gotoTeam('')" class="post-button">Back</div>
      </div>
    </div>
    <div class="segment" v-if="team" style="padding-top:64px;">
      <div class="content narrow">
        <Resistance v-if="team === 'resistance'" />
        <RepublicArmy v-if="team === 'republicArmy'" />
        <Civilian v-if="team === 'civilians'" />
        <CoalitionForces v-if="team === 'coalitionForces'" />
        <Raiders v-if="team === 'raiders'" />
      </div>
      <div class="post-button-wrapper back-button">
        <div @click="gotoTeam('')" class="post-button">Back</div>
      </div>
    </div>
    <div class="segment" v-if="!team">

      <div class="content narrow">
        <div class="post column" style="padding:0px;">
          <div class="post-banner">
            <img src="@/assets/pagebanner-teams.jpg">
          </div>
        </div>

        <div class="post bg-yellow big-text">
          <div class="image">
            <video autoplay playsinline loop src="@/assets/2026/mercs3.mp4" style="height: 100%; width: 100%; object-fit: cover;" />
          </div>
          <div class="post-content-wrapper">
            <div class="post-header">Mercenaries</div>
            <div class="post-content">
              Infantry<br>
              Mechanized Unit<br>
              Breach & Demolition Unit<br>
              Phantom Unit<br>
              Reconnaissance Unit
            </div>
            <div class="post-button-wrapper">
              <div @click="gotoTeam('resistance')" class="post-button">LEARN MORE</div>
            </div>
          </div>
        </div>

        <div class="post bg-red" v-if="0">
          <div class="image">
            <img src="../assets/team1.jpg">
          </div>
          <div class="post-content-wrapper">
            <div class="post-header">red</div>
            <div class="post-content">

            </div>
            <div class="post-button-wrapper">
              <div @click="gotoTeam('republicArmy')" class="post-button">LEARN MORE</div>
            </div>
          </div>
        </div>

        <div class="post bg-green">
          <div class="image">
            <video autoplay playsinline loop src="@/assets/2026/civ3.mp4" style="height: 100%; width: 100%; object-fit: cover;" />
          </div>
          <div class="post-content-wrapper">
            <div class="post-header">Civilians and Gangs</div>
            <div class="post-content">
              Civilians<br>
              Regional Election Committee<br>
              Odin’s Wolves MC<br>
              Sons of the North
            </div>
            <div class="post-button-wrapper">
              <div @click="gotoTeam('civilians')" class="post-button">LEARN MORE</div>
            </div>
          </div>
        </div>

        <div class="post bg-blue">
          <div class="image">
            <video autoplay playsinline loop src="@/assets/2026/ndg3.mp4" style="height: 100%; width: 100%; object-fit: cover;" />
          </div>
          <div class="post-content-wrapper">
            <div class="post-header">Nordland Defence Group (NDG)</div>
            <div class="post-content">
              Infantry<br>
              Mechanized Unit<br>
              Rangers & Reconnaissance Unit<br>
              Light Mechanized Reconnaissance Unit (LMRU)<br>
              Military Police Detachment (MPD)<br>
              Combat Medic Unit (CMU)
            </div>
            <div class="post-button-wrapper">
              <div @click="gotoTeam('coalitionForces')" class="post-button">LEARN MORE</div>
            </div>
          </div>
        </div>

        <div class="post bg-white" v-if="0">
          <div class="image"><img src="../assets/teamRaiders.jpg"></div>
          <div class="post-content-wrapper">
            <div class="post-header">Raiders</div>
            <div class="post-content">
              Raiders
            </div>
            <div class="post-button-wrapper">
              <div @click="gotoTeam('raiders')" class="post-button">LEARN MORE</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import Resistance from '@/views/Teams/Resistance'
import RepublicArmy from '@/views/Teams/RepublicArmy'
import Civilian from '@/views/Teams/Civilian'
import CoalitionForces from '@/views/Teams/CoalitionForces'
import Raiders from '@/views/Teams/Raiders.vue'
export default {
  name: 'teams',
  components: { CoalitionForces, Civilian, RepublicArmy, Resistance, Raiders },
  computed: {
    team () {
      return this.$route.params.team
    }
  },
  methods: {
    gotoTeam (team) {
      const currentTeam = this.team
      if (team === '') {
        this.$router.replace('/teams')
      } else if (currentTeam) {
        this.$router.replace('/teams/' + team)
      } else {
        this.$router.push('/teams/' + team)
      }
    }
  }
}
</script>

<style scoped>

</style>
